export default __webpack_public_path__ + "static/media/img3.218beb19.png";